import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import katrina from 'src/assets/images/fortune/katrina.svg';
import { UserInfo, UserInfoProps } from './UserInfo';

type PointGetUserInfoProps = UserInfoProps;

export const PointGetUserInfo: React.FC<PointGetUserInfoProps> = props => {
  const { t } = useTranslation('fortune');
  return (
    <div
      className={css`
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 12px 20px 0;
      `}
    >
      <UserInfo {...props} />

      <div
        className={css`
          position: relative;
          top: -20px;
          font-size: 14px;
          width: 100%;
          background: #fffff2;
          border-radius: 12px;
          padding: 16px 12px 12px;
          .supervise {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #7f2ce8;
            text-align: center;
            &::before {
              content: url(${katrina});
              flex: 0 0 auto;
              width: 28px;
              height: 28px;
              margin: 0 4px 0 0;
              transform: rotate(-4deg);
            }
          }
          .supervise-desc {
            width: 100%;
            color: #4d3906;
            text-align: center;
            margin: 4px 0 0;
          }
        `}
      >
        <p className="supervise">{t('supervised_by')}</p>
        <p className="supervise-desc">{t('collect_point_desc_02')}</p>
      </div>
    </div>
  );
};
